import { Routes } from '@angular/router';
import { antiGuard, isLoggedGuard } from './guards';

export const appRoutes: Routes = [
  {
    path: 'login',
    canActivate: [antiGuard],
    loadComponent: async () => (await import('./login/login.component')).LoginComponent,
  },
  {
    path: '',
    canActivate: [isLoggedGuard],
    loadComponent: async () => (await import('./dashboard/dashboard.component')).DashboardComponent,
  },
  {
    path: 'request-password-reset',
    canActivate: [antiGuard],
    loadComponent: async () => (await import('./request-reset-password/request-reset-password.component')).RequestResetPasswordComponent,
  },
  {
    path: 'reset-password/:hash',
    canActivate: [antiGuard],
    loadComponent: async () => (await import('./reset-password/reset-password.component')).ResetPasswordComponent,
  },
];
